export default () => ({
  trigger: {
    name: 'overarching_product_line.show',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
